
import { useState, useEffect } from 'react';

type BreakpointSize = 'mobile' | 'tablet' | 'desktop';

interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  currentBreakpoint: BreakpointSize;
  showMobileVersion: boolean;
  showDesktopVersion: boolean;
}

const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
} as const;

export const useResponsiveComponent = (): ResponsiveState => {
  const [state, setState] = useState<ResponsiveState>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    currentBreakpoint: 'desktop',
    showMobileVersion: false,
    showDesktopVersion: true,
  });

  useEffect(() => {
    const updateResponsiveState = () => {
      const width = window.innerWidth;
      
      const isMobile = width < BREAKPOINTS.mobile;
      const isTablet = width >= BREAKPOINTS.mobile && width < BREAKPOINTS.tablet;
      const isDesktop = width >= BREAKPOINTS.tablet;
      
      const currentBreakpoint: BreakpointSize = 
        isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';

      setState({
        isMobile,
        isTablet,
        isDesktop,
        currentBreakpoint,
        showMobileVersion: isMobile,
        showDesktopVersion: !isMobile,
      });
    };

    // Set initial state
    updateResponsiveState();

    // Add event listeners
    window.addEventListener('resize', updateResponsiveState);
    window.addEventListener('orientationchange', updateResponsiveState);

    return () => {
      window.removeEventListener('resize', updateResponsiveState);
      window.removeEventListener('orientationchange', updateResponsiveState);
    };
  }, []);

  return state;
};
